export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de lotes"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datos del lote"])},
          "title_packages": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empaques"])},
          "title_package_quality_inspects": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inspecciones de calidad"])},
          "title_harvested_batches": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cosechas"])},
          "edit_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Editar"])},
          "new_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nueva cosecha"])},
          "destroy_button_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar"])},
          "destroy_button_title": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Eliminar lote: ", _interpolate(_named("batch_code"))])},
          "destroy_button_message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["¿Está seguro de eliminar el lote?"])},
          "destroy_button_label_confirm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar"])},
          "destroy_harvested_batch_button_title": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Eliminar cosecha: ", _interpolate(_named("batch_code"))])},
          "destroy_harvested_batch_button_message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["¿Está seguro de eliminar la cosecha?"])}
        }
      }
    }
  })
}